/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {FormControl as BootstrapFormControl} from 'react-bootstrap';
import React, {ReactNode} from 'react';
import Props from './Props';

class FormControl extends React.Component<Props> {

	static defaultProps: Props = {
		autoComplete: undefined,
		autoFocus: false,
		disabled: undefined,
		name: undefined,
		onChange: () => {
			// do nothing
		},
		onEnter: () => {
			// do nothing
		},
		placeholder: undefined,
		readOnly: false,
		className: '',
		type: '',
		isInvalid: false,
		value: ''
	};

	handleKeyDown = (event: React.KeyboardEvent<never>): void => {
		const props: Readonly<Props> = this.props;

		// noinspection JSDeprecatedSymbols
		if ((event.key === 'Enter' || event.keyCode === 13) && !event.shiftKey) {
			event.preventDefault();
			event.stopPropagation();
			props.onEnter();
		}
	};

	render(): ReactNode {
		const props: Readonly<Props> = this.props;

		return (
			<BootstrapFormControl
				autoComplete={props.autoComplete}
				autoFocus={props.autoFocus}
				className={props.className}
				disabled={props.disabled}
				name={props.name}
				onChange={props.onChange}
				onKeyDown={this.handleKeyDown}
				placeholder={props.placeholder}
				readOnly={props.readOnly}
				type={props.type}
				isInvalid={props.isInvalid}
				value={props.value}/>
		);
	}
}

export default FormControl;
